import { render, staticRenderFns } from "./recent-proof-lists.vue?vue&type=template&id=7889e512&scoped=true&"
import script from "./recent-proof-lists.vue?vue&type=script&lang=js&"
export * from "./recent-proof-lists.vue?vue&type=script&lang=js&"
import style0 from "./recent-proof-lists.vue?vue&type=style&index=0&id=7889e512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889e512",
  null
  
)

export default component.exports